/* eslint-disable import/no-anonymous-default-export */
import * as React from 'react';
import {
    FilterList,
    FilterLiveSearch,
    FilterListItem,
    useGetIdentity,
} from 'react-admin';
import { Box } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';

import { useConfigurationContext } from '../../root/ConfigurationContext';

export const FundListFilter = () => {
    const { identity } = useGetIdentity();
    const { fundCorporations } = useConfigurationContext();
    const corps = fundCorporations.map(corporation => ({
        id: corporation,
        name: corporation,
    }));
    return (
        <Box width="13em" minWidth="13em" order={-1} mr={2} mt={5}>
            <FilterLiveSearch hiddenLabel />

            <FilterList label="Corporation" icon={<BusinessIcon />}>
                {corps.map(corporation => (
                    <FilterListItem
                        key={corporation.id}
                        label={corporation.name}
                        value={{ corporation: corporation.id }}
                    />
                ))}
            </FilterList>

        </Box>
    );
};
